import { withStyles } from "@material-ui/core/styles";
import Loading from "./Loading";
import styles from "./styles";

export default withStyles(styles)(Loading);
